export default "__VITE_ASSET__3f65808b__"